export interface ElementAttachFileResponseArgs {
  id: number;
  trip_id: number;
  upload_file_name: string;
  content_type: string;
  file_path: string;
  traveler_information_id: number | null;
  attachable_type: string;
  attachable_id: number;
}

export interface ElementAttachFileArgs {
  id: number;
  tripId: number;
  uploadFileName: string;
  contentType: string;
  filePath: string;
  travelerInformationId: string | null;
  attachableType: string;
  attachableId: number;
}

export const convertElementAttachFileResponseToArgs = (
  response: ElementAttachFileResponseArgs
): ElementAttachFileArgs => {
  return {
    id: response.id,
    tripId: response.trip_id,
    uploadFileName: response.upload_file_name,
    contentType: response.content_type,
    filePath: response.file_path,
    travelerInformationId: response.traveler_information_id?.toString() ?? null,
    attachableType: response.attachable_type,
    attachableId: response.attachable_id
  };
};

export default class ElementAttachFile {
  id: number;

  tripId: number;

  uploadFileName: string;

  contentType: string;

  filePath: string;

  travelerInformationId: string | null;

  attachableType: string;

  attachableId: number;

  constructor(args: ElementAttachFileArgs) {
    this.id = args.id;
    this.tripId = args.tripId;
    this.uploadFileName = args.uploadFileName;
    this.contentType = args.contentType;
    this.filePath = args.filePath;
    this.travelerInformationId = args.travelerInformationId;
    this.attachableType = args.attachableType;
    this.attachableId = args.attachableId;
  }

  updateParams() {
    return {
      trip_id: this.tripId,
      traveler_information_id: this.travelerInformationId,
      upload_file_name: this.uploadFileName,
      content_type: this.contentType,
      file_path: this.filePath,
      attachable_type: this.attachableType,
      attachable_id: this.attachableId
    };
  }
}
